import clsx from 'clsx'
import { FormEvent, forwardRef, useRef } from 'react'

import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Input, InputGroup, InputLeftAddon } from '@wartek-id/input'

import { xssSafeString } from '@/utils/string'

export interface LocalSearchProps {
  initialValue?: string
  placeholder?: string
  onSubmit?: (keyword: string) => void
  formClass?: string
}

type Ref = HTMLFormElement

export const LocalSearch = forwardRef<Ref, LocalSearchProps>(function Component(
  { initialValue = '', placeholder = 'Cari nama daerah', onSubmit, formClass },
  ref
) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const keyword = inputRef?.current?.value || ''
    const safeKeyword = xssSafeString(keyword)

    if (typeof onSubmit === 'function') {
      onSubmit?.(safeKeyword)
    }
  }

  return (
    <form
      className={clsx(
        'flex w-full items-center justify-end gap-2 md:w-[400px]',
        formClass
      )}
      id="local-search-box"
      onSubmit={handleSubmit}
      ref={ref}
    >
      <InputGroup>
        <InputLeftAddon>
          <Icon>search</Icon>
        </InputLeftAddon>
        <Input
          id="txt-local-search"
          data-testid="txt-local-search"
          placeholder={placeholder}
          name="searchText"
          defaultValue={initialValue}
          ref={inputRef}
          size="sm"
          className="!pr-1"
        />
      </InputGroup>
      <Button color="black" type="submit" data-testid="btn-local-search">
        Cari
      </Button>
    </form>
  )
})
